<template>
  <div class="search">
    <search-title-bar
      :keyWords="keyWords"
      @keypress="keypress"
      @blurKey="blurKey"
    />
    <div class="line_height"></div>
    <div v-if="!keyWords">
      <!-- 历史搜索 -->
      <history-list
        :searchKeys="searchOrderKeys"
        @deleteHis="deleteHis"
        @clickHistoryItem="clickHistoryItem"
      />
    </div>
    <!-- 订单 -->
    <div
      v-if="
        keyWords &&
          findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length > 0
      "
    >
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="!findClientRetailOrderByParam.hasNextPage"
          finished-text="我已经到底啦～"
          @load="onLoad"
        >
          <div class="order_list_items">
            <div
              v-for="(item, index) in findClientRetailOrderByParam.rows"
              :key="index"
              class="items"
            >
              <!-- 订单头部信息 -->
              <order-header :storeDet="item" />
              <div v-for="(i, index1) in item.retailSubOrderList" :key="index1">
                <div
                  v-if="item.retailSubOrderList.length > 1"
                  :class="{ bao_mr: index1 !== 0 }"
                  class="font12 font_weight500 colo087 text_left bao_name"
                >
                  包裹{{ index1 + 1 }}
                </div>
                <!-- 商品信息 -->
                <order-product-list
                  v-for="(i1, index2) in i.orderDetailList"
                  :key="index2"
                  :listIndex="index2"
                  :pageShow="false"
                  :item="i1"
                  :i="item"
                  @goOrderDetail="goOrderDetail"
                />
                <!-- 多包裹底部按钮 -->
                <bottom-btn
                  v-if="item.retailSubOrderList.length > 1"
                  :btnList="
                    orderBtn(
                      item.retailSubOrderList.length,
                      i.orderType,
                      i.status
                    )
                  "
                  :i="i"
                  :item="item"
                  :packageIndex="index1"
                  @clickBtn="clickBtn"
                />
              </div>
              <!-- 订单（单包裹）底部按钮 -->
              <bottom-btn
                v-if="item.retailSubOrderList.length === 1"
                :btnList="
                  orderBtn(
                    item.retailSubOrderList.length,
                    item.orderType,
                    item.status
                  )
                "
                :item="item"
                :i="item.retailSubOrderList[0]"
                @clickBtn="clickBtn"
              />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 无结果 -->
    <div
      v-if="
        keyWords &&
          findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length === 0
      "
      class="none_list"
    >
      <img src="@/assets/order/search_none_product@2x.png" alt="" />
      <div class="font14 font_weight400 colo038 line_height_20">
        未找到相关订单
      </div>
    </div>
  </div>
</template>
<script>
import SearchTitleBar from "./components/SearchTitleBar";
import HistoryList from "../../search/components/HistoryList";
import OrderHeader from "../list/components/OrderHeader";
import OrderProductList from "../list/components/OrderProductList";
import BottomBtn from "../list/components/BottomBtn";
export default {
  name: "Search",
  components: {
    SearchTitleBar,
    HistoryList,
    OrderHeader,
    OrderProductList,
    BottomBtn
  },
  data() {
    return {
      lookAllProduct: false,
      keyWords: "",
      // isList: false,
      noList: false,
      loading: false
    };
  },
  computed: {
    findClientRetailOrderByParam() {
      return this.$store.getters.findClientRetailOrderByParam;
    },
    searchOrderKeys() {
      const searchOrderKeys = this.$store.getters.searchOrderKeys.filter(
        item => item !== null && item !== ""
      );
      return searchOrderKeys;
    }
  },
  mounted() {
    const str = localStorage.SEARCH_ORDER_KEYS;
    if (str && str !== null) {
      this.$store.dispatch("order/initSearchOrderKeys", {
        keys: JSON.parse(str),
        callback: () => {}
      });
    }
  },
  // this.$store.dispatch("order/setSearchOrderKeys", {
  //       keywords: this.keyWords.trim()
  //     });
  methods: {
    getData(keywords, pageNo = 1, pageSize = 20) {
      const params = {
        pageNo,
        pageSize,
        keywords
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/findClientRetailOrderByParam", { params })
        .then(() => {
          this.loading = false;
          // console.log(1111);
        })
        .catch(() => {});
    },
    onRefresh() {
      this.getData(this.keywords);
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loading = false;
      if (
        this.findClientRetailOrderByParam.hasNextPage &&
        this.findClientRetailOrderByParam.pageNo <
          this.findClientRetailOrderByParam.pageCount
      ) {
        this.loading = true;
        const pageIndex = this.findClientRetailOrderByParam.pageNo + 1;
        this.getData(this.switchIndex, pageIndex);
        // console.log("上拉完毕");
      }
    },
    // 搜索框输入字段
    keypress(value, eventcode) {
      if (eventcode.keyCode === 13 && value) {
        this.keyWords = value;
        this.getData(this.keyWords.trim());
        this.$store.dispatch("order/setSearchOrderKeys", {
          keywords: this.keyWords
        });
        // console.log(localStorage.SEARCH_ORDER_KEYS);
        // this.isList = true;
      } else {
        this.keyWords = value;
      }
    },
    blurKey(value) {
      // console.log(value, "blurValue");
      this.keyWords = value;
    },
    // 删除历史
    deleteHis() {
      if (localStorage.SEARCH_ORDER_KEYS) {
        localStorage.removeItem("SET_SEARCH_ORDER_KEYS");
        this.$store.dispatch("order/initSearchOrderKeys", {
          keys: [],
          callback: () => {}
        });
      }
    },
    clickHistoryItem(keyWords) {
      this.getData(keyWords);
      this.keyWords = keyWords;
      // this.isList = true;
    },
    // 跳转详情
    goOrderDetail(orderSn) {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderSn
        }
      });
    },
    orderBtn(orderListLength, orderType, status) {
      // orderListLength 通过包裹的长度 1是单包裹，>1是多包裹
      // orderType 0普通商品 1周期购 2虚拟卡
      // afterType 0不可取消 1可取消 2可售后
      // status 订单状态(单包裹订单维度状态，多包裹是包裹维度的状态)
      switch (status) {
        // 待付款
        case 10:
          return [
            {
              name: "取消订单",
              isLightHeight: false
            },
            {
              name: "去付款",
              isLightHeight: true
            }
          ];
        // 待发货
        case 11:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 待收货
        case 12:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                ];
            }
          }
          break;
        // 已完成
        case 13:
        case 14:
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                // 未兑换的 购买的 卡。展示前往使用？
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 已关闭
        case -10:
        case -11:
          return [
            {
              name: "再次购买",
              isLightHeight: false
            }
          ];
      }
    },
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.getData(this.keywords);
          this.showCancel = false;
          this.$toast("订单取消成功");
        })
        .catch(() => {});
    },
    // 删除接口
    deleteData(orderSn) {
      this.$store
        .dispatch("order/deleteOrder", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.getData(this.keywords);
          this.showCancel = false;
          this.$toast("订单删除成功");
        })
        .catch(() => {});
    },
    // 再次购买接口
    againBuy(orderSn) {
      this.$store
        .dispatch("order/againBuy", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.$router.push("/cart");
        })
        .catch(() => {});
    },
    // 确认收货
    confirmOrder(subOrderSn) {
      this.$store
        .dispatch("order/confirmOrder", {
          params: {
            subOrderSn
          }
        })
        .then(() => {
          this.getData(this.keywords);
        })
        .catch(() => {});
    },
    getSpuId(item) {
      const { retailSubOrderList } = item;
      let spuId = "";
      retailSubOrderList.forEach(item => {
        item.orderDetailList.forEach(i => {
          if (!i.isGift) {
            spuId = i.spuId;
            return;
          }
        });
      });
      return spuId;
    },
    // 点击按钮
    clickBtn(name, orderSn, subOrderSn, packageIndex, orderType, spuId, item) {
      switch (name) {
        case "取消订单":
          this.showCancel = true;
          this.orderSn = orderSn;
          break;
        case "去付款":
          // /order/orderpay?orderSn=FY20112062347625
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn
            }
          });
          break;
        case "查看物流":
          this.$router.push({
            path: "/order/detail/logistics",
            query: {
              orderSn,
              subOrderSn,
              packageIndex
            }
          });
          break;
        case "提醒发货":
          this.$toast("已提醒发货");
          break;
        case "申请退款":
          this.$router.push({
            path: "/order/refund/orderdetailrefundreasion",
            query: {
              orderSn,
              name: this.getUserOrder.address.name,
              phone: this.getUserOrder.address.phone
            }
          });
          break;
        case "确认收货":
          this.$dialog
            .confirm({
              message: "您确定要确认收货吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              // 确认收货
              this.confirmOrder(subOrderSn);
            })
            .catch(() => {});
          break;
        case "再次购买":
          if (orderType === 0) {
            this.againBuy(orderSn);
          } else {
            // 跳转详情
            this.$router.push({
              path: "/product/detail",
              query: {
                id: spuId || this.getSpuId(item)
              }
            });
          }
          break;
        case "申请售后":
          this.$router.push({
            path: "/order/refund/applypackage",
            query: {
              orderType: this.getUserOrder.orderType,
              orderSn
            }
          });
          break;
        case "删除订单":
          this.$dialog
            .confirm({
              message: "您确定要删除该订单吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.deleteData(orderSn);
            })
            .catch(() => {});
          break;
        case "配送计划":
          this.$router.push({
            path: "/order/milkplan",
            query: {
              orderSn,
              subOrderSn
            }
          });
          break;
        case "前往使用":
          this.$router.push({
            path: "/mine/cardpackagelist"
          });
          break;
      }
    },
    // 取消订单
    cancelOrder() {
      this.showCancel = true;
    }
  }
};
</script>
<style lang="less" scoped>
.search {
  // background: #fff;
  .line_height {
    height: 48px;
  }
  .order_list_items {
    // padding-top: 47px;
    .items {
      background: #fff;
      margin-top: 12px;
      .bao_name {
        padding: 4px 12px;
      }
      .bao_mr {
        border-top: 4px solid #f6f7f8;
      }
    }
  }
  .none_list {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 60px;
    }
  }
}
</style>
